const sendMail = {
    dispatchWebBaseUrl: 'https://dispatchweb.eureka-technology.fr/',
};

export default sendMail;
